import { FC } from 'react'
import clsx from 'clsx'
import Image from 'next/image'
import { GetServerSideProps } from 'next'
import { useRouter } from 'next/router'
import Link from 'next/link'

import MainLayout from 'containers/main-layout/main-layout'
import SEOMetatags from 'components/parts/seo-metatags/seo-metatags'
import SEOAIBolit from 'components/parts/seo-metatags/seo-aibolit'
import Navbar from 'components/global/navbar/navbar'
import WidthLimiter from 'containers/width-limiter/width-limiter'
import AiLangingHeader from 'components/ai-bolit/landing/ai-landing-header/ai-landing-header'
import LangingProfit from 'components/ai-bolit/landing/landing-profit/landing-profit'
import AiLangingBanner from 'components/ai-bolit/landing/ai-landing-banner/ai-landing-banner'

import checkTokenExist from 'utils/checkTokenExist'
import { Pathname, STATIC_URL } from 'constants/data'
import { cutHashFromURL } from 'utils/getURLData'
import { popupName } from 'constants/auth/auth-data'
import { BotAiLandingSEO } from 'constants/SEO'

import styles from 'components/ai-bolit/landing/landing-common.module.scss'

const imgLogo = {
  src: `${STATIC_URL}/ai-bolit/aibolit-logo.png`,
  alt: 'Задний фон',
  width: 43,
  height: 46,
  unoptimized: true,
}

const AiLanding: FC = () => {
  const router = useRouter()
  const path = cutHashFromURL(router.asPath)

  return (
    <>
      <SEOAIBolit />
      <SEOMetatags data={BotAiLandingSEO} />
      <MainLayout noHeader noBtnUp modificator={styles.modMain}>
        <Navbar onlyLogo isInformLineHide={true}>
          <Link href={`${path}#${popupName.registration}`}>
            <div className={styles.btnReg}>Войти в аккаунт</div>
          </Link>
        </Navbar>
        <WidthLimiter noBottomPadding noTopPadding>
          <AiLangingHeader />
          <div className={styles.section}>
            <h2 className={clsx(styles.h2, styles.h2Helper1)}>
              AI Bolit — это инновационный сервис, разработанный специально для врачей
            </h2>
            <div className={styles.txt}>
              Он объединяет мощь искусственного интеллекта с обширной базой клинических
              рекомендаций, чтобы предоставить вам мгновенный доступ к актуальной медицинской
              информации
            </div>
          </div>
          <LangingProfit />
          <div className={styles.section}>
            <h2 className={styles.subtitle}>
              <Image {...imgLogo} className={styles.logo} /> AI Bolit — это{' '}
              <span className={styles.light}>больше, чем&nbsp;просто инструмент. </span>
              Надежный&nbsp;помощник, который позволяет вам сосредоточиться на&nbsp;самом главном —
              заботе о здоровье ваших пациентов.
            </h2>
          </div>
          <AiLangingBanner />
        </WidthLimiter>
      </MainLayout>
    </>
  )
}

export const getServerSideProps: GetServerSideProps = async (context) => {
  const reqCookies = context.req.headers.cookie
  const isToken = checkTokenExist(reqCookies)
  try {
    if (isToken) {
      return {
        redirect: {
          destination: `/${Pathname.AI_BOLIT}`,
          permanent: true,
        },
      }
    }
  } catch {
    console.log('LOST ID')
  }

  return {
    props: {},
  }
}

export default AiLanding
